module.exports = __webpack_public_path__ + "static/pensjonat-glowne-photo01-08e2576ea822d8b9995f6156678048c4.jpg";